export const WOP = 'WOP'
export const WP = 'WP'
